import { MarkdownDocPage } from "@/components/MarkdownDocPage";
import { createFileRoute } from "@tanstack/react-router";
import adminMd from "../../../docs/phase1-admin-guide.md?raw";

export const Route = createFileRoute("/docs/phase1/admin")({
	component: () => <MarkdownDocPage source={adminMd} />,
});
